import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

export default defineNuxtPlugin({
  name: 'v-calendar',
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.use(setupCalendar, {});
    nuxtApp.vueApp.component('VCalendar', Calendar);
    nuxtApp.vueApp.component('VDatePicker', DatePicker);
  },
});
